<script>
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import Product from '@maison/components/common/Product';
import { TAB_PRODUCTS, URL_FILTERS_SEARCH_NAME } from '@maison/helpers/search-helper';
import AlgoliaSearch, { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';
import AlgoliaMixedGridFilters from '@maison/components/algolia/AlgoliaMixedGridFilters.vue';
import { mapActions } from 'vuex';
import { rescue } from '@phoenix/helpers/common-helper';

export default {
  components: {
    AlgoliaMixedGridFilters,
    SearchResultsTab,
    Product,
  },

  mixins: [searchResultsTabMixin],

  props: {
    uniqueId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tab: TAB_PRODUCTS,
      hasFilters: AlgoliaSearch.isEnabled(),
      teleportTargetExists: false,
    };
  },

  computed: {
    shouldDisplayFilters() {
      return this.hasFilters && this.limit === 0;
    },

    filters() {
      return JSON.parse(JSON.stringify(this.tabResult.filters));
    },

    urlParamPrefix() {
      return `${URL_FILTERS_SEARCH_NAME}.${this.tab}`;
    },

    productsCount() {
      return this.tabResult.total;
    },
  },

  mounted() {
    requestAnimationFrame(() => {
      this.teleportTargetExists = true;
    });
  },

  methods: {
    ...mapActions('search', ['changeCurrentTab', 'loadData', 'setSortOption', 'setActiveFilters']),

    async onSortChanged(sortOption) {
      this.setSortOption({ tab: this.tab, sortOption });
      await this.loadData({ clearData: true, tab: this.tab });
    },

    async onFiltersChanged(filters) {
      this.setActiveFilters({ tab: this.tab, filters });
      await this.loadData({ clearData: true, tab: this.tab });

      rescue(() => {
        const formattedFilters = Object.entries(filters)
          .map(([category, values]) => `${category};${Array.isArray(values) ? values.join(';') : values}`)
          .join('|');

        window.tracking.pushEvent(window.tracking.getSearchFilterViewResultsTracking(this.query, formattedFilters));
      });
    },

    onProductClick(product, position) {
      algoliaTracking(product, position, IndexNames.Products);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit">
    <teleport v-if="teleportTargetExists && shouldDisplayFilters" to="#teleport-target-search-panel-filters">
      <div v-show="isTabActive">
        <algolia-mixed-grid-filters
          :unique-id="uniqueId"
          :filters="filters"
          :products-count="productsCount"
          :should-display-products-count="false"
          :url-param-prefix="urlParamPrefix"
          has-filters-in-url
          @on-sort-changed="onSortChanged"
          @on-filters-changed="onFiltersChanged"
        />
      </div>
    </teleport>

    <product
      v-for="(product, position) in items"
      :key="product.modelReference"
      v-bind="product"
      enable-slider
      :data-tracking="dataTracking"
      @click="onProductClick(product, position)"
    />
  </search-results-tab>
</template>
